var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "isd d-inline-block" },
    [
      _c(
        "svg",
        {
          staticClass: "isd-sprite",
          attrs: { "aria-hidden": "true", focusable: "false" },
        },
        [
          _c("defs", [
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.bookOpen,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M12 7v14" } }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.listOrdered,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M10 12h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M10 18h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M10 6h11" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M4 10h2" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M4 6h1v4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.chevronDown,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [_c("path", { attrs: { d: "m6 9 6 6 6-6" } })]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.chevronUp,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [_c("path", { attrs: { d: "m18 15-6-6-6 6" } })]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.chevronRight,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [_c("path", { attrs: { d: "m9 18 6-6-6-6" } })]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.wand,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
                  },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m14 7 3 3" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M5 6v4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M19 14v4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M10 2v2" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M7 8H3" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M21 16h-4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M11 3H9" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.chartColumn,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M3 3v16a2 2 0 0 0 2 2h16" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M18 17V9" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M13 17V5" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M8 17v-3" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.sparkles,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
                  },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M20 3v4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M22 5h-4" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M4 17v2" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M5 18H3" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.check,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.pencilLine,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M12 20h9" } }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
                  },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m15 5 3 3" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.bookmarkPlus,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
                  },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: { x1: "12", x2: "12", y1: "7", y2: "13" },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: { x1: "15", x2: "9", y1: "10", y2: "10" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.settings,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
                  },
                }),
                _vm._v(" "),
                _c("circle", { attrs: { cx: "12", cy: "12", r: "3" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.trash2,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M3 6h18" } }),
                _vm._v(" "),
                _c("path", {
                  attrs: { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: { x1: "10", x2: "10", y1: "11", y2: "17" },
                }),
                _vm._v(" "),
                _c("line", {
                  attrs: { x1: "14", x2: "14", y1: "11", y2: "17" },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.x,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M18 6 6 18" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m6 6 12 12" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.search,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m21 21-4.3-4.3" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.plus,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "M5 12h14" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M12 5v14" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.pencil,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                  },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "m15 5 4 4" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.arrowLeft,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", { attrs: { d: "m12 19-7-7 7-7" } }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M19 12H5" } }),
              ]
            ),
            _vm._v(" "),
            _c(
              "symbol",
              {
                attrs: {
                  id: _vm.iconIds.save,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" },
                }),
                _vm._v(" "),
                _c("path", { attrs: { d: "M7 3v4a1 1 0 0 0 1 1h7" } }),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown" }, [
        _c(
          "button",
          {
            ref: "triggerBtn",
            staticClass: "btn isd__btn",
            class: { "isd__btn--open": _vm.isOpen },
            attrs: {
              id: _vm.triggerId,
              type: "button",
              "data-toggle": "dropdown",
              "aria-haspopup": "true",
              "aria-expanded": _vm.isOpen ? "true" : "false",
              title: "Choose the sequence driving this report",
            },
            on: { click: _vm.handleToggle },
          },
          [
            _c(
              "span",
              { staticClass: "isd__btnIcon", attrs: { "aria-hidden": "true" } },
              [
                _c(
                  "svg",
                  {
                    staticClass: "isd-svg isd-svg--16",
                    attrs: { "aria-hidden": "true" },
                  },
                  [
                    _c("use", {
                      attrs: {
                        href: `#${_vm.iconIds.listOrdered}`,
                        "xlink:href": `#${_vm.iconIds.listOrdered}`,
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "isd__btnLabel text-truncate" }, [
              _vm._v("\n        " + _vm._s(_vm.activeLabel) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "isd__btnChevron",
                attrs: { "aria-hidden": "true" },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "isd-svg isd-svg--12",
                    attrs: { "aria-hidden": "true" },
                  },
                  [
                    _c("use", {
                      attrs: {
                        href: `#${_vm.iconIds.chevronDown}`,
                        "xlink:href": `#${_vm.iconIds.chevronDown}`,
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "dropdown-menu dropdown-menu-right isd__menu",
            attrs: { "aria-labelledby": _vm.triggerId },
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "isd__sectionTitle" }, [
              _c(
                "span",
                {
                  staticClass: "isd__sectionIcon",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "isd-svg isd-svg--14",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          href: `#${_vm.iconIds.wand}`,
                          "xlink:href": `#${_vm.iconIds.wand}`,
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v("\n        Auto sources\n      "),
            ]),
            _vm._v(" "),
            _vm._l(_vm.autoSources, function (src) {
              return _c(
                "button",
                {
                  key: src.id,
                  staticClass: "dropdown-item isd__item",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.selectSource(src)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "isd__itemIcon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "isd-svg isd-svg--14",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              href: `#${_vm.iconIds[src.iconKey]}`,
                              "xlink:href": `#${_vm.iconIds[src.iconKey]}`,
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "isd__itemBody" }, [
                    _c(
                      "span",
                      { staticClass: "isd__itemTitle text-truncate" },
                      [_vm._v(_vm._s(src.title))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "isd__itemSub text-truncate" }, [
                      _vm._v(_vm._s(src.subtitle)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.activeType === "auto" && _vm.activeId === src.id
                    ? _c(
                        "span",
                        {
                          staticClass: "isd__check",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "isd-svg isd-svg--14 isd-svg--check",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: {
                                  href: `#${_vm.iconIds.check}`,
                                  "xlink:href": `#${_vm.iconIds.check}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              )
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "isd__sectionTitle" }, [
              _c(
                "span",
                {
                  staticClass: "isd__sectionIcon",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "isd-svg isd-svg--14",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          href: `#${_vm.iconIds.bookOpen}`,
                          "xlink:href": `#${_vm.iconIds.bookOpen}`,
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v("\n        Playbooks\n        "),
              _c("span", { staticClass: "isd__sectionMeta" }, [
                _vm._v("visual sequences"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "isd__searchWrap" }, [
              _c(
                "span",
                {
                  staticClass: "isd__searchIcon",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "isd-svg isd-svg--12",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          href: `#${_vm.iconIds.search}`,
                          "xlink:href": `#${_vm.iconIds.search}`,
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.playbookSearch,
                    expression: "playbookSearch",
                  },
                ],
                staticClass: "form-control isd__searchInput",
                attrs: { placeholder: "Search playbooks…" },
                domProps: { value: _vm.playbookSearch },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.playbookSearch = $event.target.value
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "isd__playbookScroll" },
              _vm._l(_vm.filteredPlaybooks, function (pb) {
                return _c(
                  "button",
                  {
                    key: pb.id,
                    staticClass: "dropdown-item isd__item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.selectPlaybook(pb)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "isd__itemIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--14",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.bookOpen}`,
                                "xlink:href": `#${_vm.iconIds.bookOpen}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "isd__itemBody" }, [
                      _c(
                        "span",
                        { staticClass: "isd__itemTitle text-truncate" },
                        [_vm._v(_vm._s(pb.title))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "isd__itemSub text-truncate" },
                        [_vm._v(_vm._s(pb.subtitle))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.activeType === "playbook" && _vm.activeId === pb.id
                      ? _c(
                          "span",
                          {
                            staticClass: "isd__check",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "isd-svg isd-svg--14 isd-svg--check",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.check}`,
                                    "xlink:href": `#${_vm.iconIds.check}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "isd__submenu",
                on: {
                  mouseenter: function ($event) {
                    _vm.seqOptionsOpen = true
                  },
                  mouseleave: function ($event) {
                    _vm.seqOptionsOpen = false
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item isd__item isd__submenuTrigger",
                    attrs: { type: "button" },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "isd__itemIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--14",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.settings}`,
                                "xlink:href": `#${_vm.iconIds.settings}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "isd__actionText" }, [
                      _vm._v("Sequence Options"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "isd__submenuChevron",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--16",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.chevronRight}`,
                                "xlink:href": `#${_vm.iconIds.chevronRight}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.seqOptionsOpen,
                        expression: "seqOptionsOpen",
                      },
                    ],
                    staticClass: "isd__submenuContent",
                    attrs: { role: "menu", "aria-label": "Sequence options" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "dropdown-item isd__item isd__action",
                        attrs: { type: "button" },
                        on: { click: _vm.openBuildModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "isd__itemIcon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "isd-svg isd-svg--14",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.pencilLine}`,
                                    "xlink:href": `#${_vm.iconIds.pencilLine}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "isd__actionText" }, [
                          _vm._v("Build a Custom Sequence…"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "dropdown-item isd__item isd__action",
                        attrs: { type: "button" },
                        on: { click: _vm.openSaveModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "isd__itemIcon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "isd-svg isd-svg--14",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.bookmarkPlus}`,
                                    "xlink:href": `#${_vm.iconIds.bookmarkPlus}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "isd__actionText" }, [
                          _vm._v("Save Current as New Sequence…"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "dropdown-item isd__item isd__action",
                        attrs: { type: "button" },
                        on: { click: _vm.openLibraryModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "isd__itemIcon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "isd-svg isd-svg--14",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.settings}`,
                                    "xlink:href": `#${_vm.iconIds.settings}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "isd__actionText" }, [
                          _vm._v("Manage Sequence Library…"),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "isd__sectionTitle" }, [
              _c(
                "span",
                {
                  staticClass: "isd__sectionIcon",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "isd-svg isd-svg--16",
                      attrs: { "aria-hidden": "true" },
                    },
                    [
                      _c("use", {
                        attrs: {
                          href: `#${_vm.iconIds.listOrdered}`,
                          "xlink:href": `#${_vm.iconIds.listOrdered}`,
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v("\n        My Sequences\n        "),
              _c("span", { staticClass: "isd__sectionMeta" }, [
                _vm._v("slot order"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "isd__seqScroll" },
              _vm._l(_vm.sequences, function (seq) {
                return _c(
                  "button",
                  {
                    key: seq.id,
                    staticClass: "dropdown-item isd__item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.selectSequence(seq)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "isd__itemIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--16",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.listOrdered}`,
                                "xlink:href": `#${_vm.iconIds.listOrdered}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "isd__itemBody" }, [
                      _c(
                        "span",
                        { staticClass: "isd__itemTitle text-truncate" },
                        [_vm._v(_vm._s(seq.name))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "isd__itemSub text-truncate" },
                        [
                          _vm._v(
                            _vm._s(seq.category) +
                              " · " +
                              _vm._s(seq.slots.length) +
                              " slots"
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.activeType === "sequence" && _vm.activeId === seq.id
                      ? _c(
                          "span",
                          {
                            staticClass: "isd__check",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass:
                                  "isd-svg isd-svg--14 isd-svg--check",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.check}`,
                                    "xlink:href": `#${_vm.iconIds.check}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade isd-modal isd-modal--save",
          attrs: {
            id: _vm.saveModalId,
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--md",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content isd-modal__content" }, [
                _c("div", { staticClass: "isd-modal__header" }, [
                  _c("div", { staticClass: "isd-modal__titleRow" }, [
                    _c(
                      "span",
                      {
                        staticClass: "isd-modal__titleIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--20",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.bookmarkPlus}`,
                                "xlink:href": `#${_vm.iconIds.bookmarkPlus}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: "isd-modal__title mb-0" }, [
                      _vm._v(
                        "\n              Save Sequence to Library\n            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "isd-modal__body" }, [
                  _c("div", { staticClass: "isd-save__field" }, [
                    _c(
                      "label",
                      {
                        staticClass: "isd-label isd-label--save",
                        attrs: { for: _vm.saveNameId },
                      },
                      [_vm._v("Name")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.saveName,
                          expression: "saveName",
                        },
                      ],
                      staticClass:
                        "form-control isd-input isd-input--h10 isd-input--rounded",
                      attrs: {
                        id: _vm.saveNameId,
                        placeholder: "e.g. MC Frozen Standard",
                      },
                      domProps: { value: _vm.saveName },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.saveName = $event.target.value
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "isd-caption" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.buildSlots.length) +
                        " slots will be saved.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "isd-modal__footer isd-modal__footer--right" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn isd-btn isd-btn--ghost",
                        attrs: { type: "button", "data-dismiss": "modal" },
                      },
                      [_vm._v("\n            Cancel\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn isd-btn isd-btn--primary",
                        attrs: { type: "button" },
                        on: { click: _vm.saveToLibrary },
                      },
                      [_vm._v("\n            Save\n          ")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "isd-modal__close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _c(
                        "svg",
                        {
                          staticClass: "isd-svg isd-svg--16",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              href: `#${_vm.iconIds.x}`,
                              "xlink:href": `#${_vm.iconIds.x}`,
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade isd-modal",
          attrs: {
            id: _vm.libraryModalId,
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--lg",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content isd-modal__content" }, [
                _c("div", { staticClass: "isd-modal__header" }, [
                  _c("div", { staticClass: "isd-modal__titleRow" }, [
                    _c(
                      "span",
                      {
                        staticClass: "isd-modal__titleIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--20",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.listOrdered}`,
                                "xlink:href": `#${_vm.iconIds.listOrdered}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: "isd-modal__title mb-0" }, [
                      _vm._v("\n              Sequence Library\n            "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "isd-modal__subtitle" }, [
                    _vm._v(
                      "\n            Reusable image sequences you can apply to any PDP. Like Audiences — but for slot order.\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "isd-modal__body" }, [
                  _c("div", { staticClass: "isd-libraryTop" }, [
                    _c("div", { staticClass: "isd-search" }, [
                      _c(
                        "span",
                        {
                          staticClass: "isd-search__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "isd-svg isd-svg--14",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: {
                                  href: `#${_vm.iconIds.search}`,
                                  "xlink:href": `#${_vm.iconIds.search}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.search,
                            expression: "search",
                          },
                        ],
                        staticClass: "form-control isd-input isd-search__input",
                        attrs: { placeholder: "Search sequences..." },
                        domProps: { value: _vm.search },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.search = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn isd-btn isd-btn--primary",
                        attrs: { type: "button" },
                        on: { click: _vm.openNewSequenceModal },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "isd-btn__icon",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "isd-svg isd-svg--14",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c("use", {
                                  attrs: {
                                    href: `#${_vm.iconIds.plus}`,
                                    "xlink:href": `#${_vm.iconIds.plus}`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v("\n              New Sequence\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "isd-libraryList" }, [
                    _c(
                      "ul",
                      { staticClass: "list-unstyled mb-0" },
                      _vm._l(_vm.filteredSequences, function (seq) {
                        return _c(
                          "li",
                          { key: `lib-${seq.id}`, staticClass: "isd-row" },
                          [
                            _c("div", { staticClass: "isd-row__main" }, [
                              _c("div", { staticClass: "isd-row__titleRow" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "isd-row__title text-truncate",
                                  },
                                  [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(seq.name) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "isd-pill" }, [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(seq.scope) +
                                      "\n                    "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "seq-slots" },
                                _vm._l(seq.slots, function (slot, index) {
                                  return _c("span", { key: slot.id }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(slot.label)
                                    ),
                                    index < seq.slots.length - 1
                                      ? _c("span", [_vm._v(" · ")])
                                      : _vm._e(),
                                  ])
                                }),
                                0
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "isd-row__actions" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn isd-btn isd-btn--primary isd-btn--h8",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.selectSequence(seq)
                                      _vm.closeAll()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Apply\n                  "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn isd-iconBtn",
                                  attrs: {
                                    type: "button",
                                    title: `Edit ${seq.name}`,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editSequence(seq)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "isd-svg isd-svg--14",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              href: `#${_vm.iconIds.pencil}`,
                                              "xlink:href": `#${_vm.iconIds.pencil}`,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn isd-iconBtn isd-iconBtn--danger",
                                  attrs: {
                                    type: "button",
                                    title: `Delete ${seq.name}`,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDelete(seq.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          staticClass: "isd-svg isd-svg--14",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [
                                          _c("use", {
                                            attrs: {
                                              href: `#${_vm.iconIds.trash2}`,
                                              "xlink:href": `#${_vm.iconIds.trash2}`,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "isd-modal__close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _c(
                        "svg",
                        {
                          staticClass: "isd-svg isd-svg--16",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              href: `#${_vm.iconIds.x}`,
                              "xlink:href": `#${_vm.iconIds.x}`,
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade isd-modal isd-modal--new",
          attrs: {
            id: _vm.newModalId,
            tabindex: "-1",
            role: "dialog",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "modal-dialog modal-dialog-centered isd-modal__dialog isd-modal__dialog--lg",
              attrs: { role: "document" },
            },
            [
              _c("div", { staticClass: "modal-content isd-modal__content" }, [
                _c("div", { staticClass: "isd-modal__header" }, [
                  _c("div", { staticClass: "isd-modal__titleRow" }, [
                    _c(
                      "span",
                      {
                        staticClass: "isd-modal__titleIcon",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "isd-svg isd-svg--20",
                            attrs: { "aria-hidden": "true" },
                          },
                          [
                            _c("use", {
                              attrs: {
                                href: `#${_vm.iconIds.listOrdered}`,
                                "xlink:href": `#${_vm.iconIds.listOrdered}`,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("h5", { staticClass: "isd-modal__title mb-0" }, [
                      _vm._v("\n              New Sequence\n            "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "isd-modal__subtitle" }, [
                    _vm._v(
                      "\n            An ordered list of slot labels (e.g. Mobile Hero, Lifestyle, How To).\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "isd-modal__body" }, [
                  _c("div", { staticClass: "isd-new__grid" }, [
                    _c("div", { staticClass: "isd-new__field" }, [
                      _c(
                        "label",
                        {
                          staticClass: "isd-label isd-label--new",
                          attrs: { for: _vm.newNameId },
                        },
                        [_vm._v("Name")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newSeqName,
                            expression: "newSeqName",
                          },
                        ],
                        staticClass:
                          "form-control isd-input isd-input--h10 isd-input--rounded",
                        attrs: {
                          id: _vm.newNameId,
                          placeholder: "e.g. MC Frozen Standard",
                        },
                        domProps: { value: _vm.newSeqName },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.newSeqName = $event.target.value
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "isd-new__field" }, [
                      _c(
                        "label",
                        {
                          staticClass: "isd-label isd-label--new",
                          attrs: { for: _vm.newScopeId },
                        },
                        [_vm._v("Scope")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newSeqScope,
                            expression: "newSeqScope",
                          },
                        ],
                        staticClass:
                          "form-control isd-input isd-input--h10 isd-input--rounded",
                        attrs: {
                          id: _vm.newScopeId,
                          placeholder: "Global or a category name",
                        },
                        domProps: { value: _vm.newSeqScope },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.newSeqScope = $event.target.value
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "isd-new__slots" }, [
                    _c("label", { staticClass: "isd-label isd-label--new" }, [
                      _vm._v("Slots (in order)"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "isd-new__slotBox" }, [
                      !_vm.newSeqSlots.length
                        ? _c("div", { staticClass: "isd-new__empty" }, [
                            _vm._v(
                              "\n                No slots yet. Add one below.\n              "
                            ),
                          ])
                        : _c(
                            "div",
                            { staticClass: "isd-new__slotList" },
                            _vm._l(_vm.newSeqSlots, function (s, idx) {
                              return _c(
                                "div",
                                {
                                  key: `new-slot-${idx}`,
                                  staticClass: "isd-new__slotRow",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "isd-new__slotNum" },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            String(idx + 1).padStart(2, "0")
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "isd-new__slotText text-truncate",
                                    },
                                    [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(s.label) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                      _vm._v(" "),
                      _c("div", { staticClass: "isd-new__slotAdd" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newSeqSlotText,
                              expression: "newSeqSlotText",
                            },
                          ],
                          staticClass:
                            "form-control isd-input isd-input--rounded isd-new__slotInput",
                          attrs: {
                            placeholder:
                              "Add slot label (e.g. Mobile Hero, Lifestyle, How To)",
                          },
                          domProps: { value: _vm.newSeqSlotText },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.preventDefault()
                              return _vm.addNewSeqSlot.apply(null, arguments)
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.newSeqSlotText = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn isd-btn isd-btn--primary isd-new__addBtn",
                            attrs: { type: "button" },
                            on: { click: _vm.addNewSeqSlot },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "isd-btn__icon",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass: "isd-svg isd-svg--14",
                                    attrs: { "aria-hidden": "true" },
                                  },
                                  [
                                    _c("use", {
                                      attrs: {
                                        href: `#${_vm.iconIds.plus}`,
                                        "xlink:href": `#${_vm.iconIds.plus}`,
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v("\n                  Add\n                "),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "isd-modal__footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn isd-btn isd-btn--ghost",
                      attrs: { type: "button" },
                      on: { click: _vm.backToLibraryFromNew },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "isd-btn__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "isd-svg isd-svg--14",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: {
                                  href: `#${_vm.iconIds.arrowLeft}`,
                                  "xlink:href": `#${_vm.iconIds.arrowLeft}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v("\n            Back to library\n          "),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn isd-btn isd-btn--primary",
                      attrs: {
                        disabled:
                          !_vm.newSeqName || _vm.newSeqSlots.length === 0,
                        type: "button",
                      },
                      on: { click: _vm.saveNewSequence },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "isd-btn__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "isd-svg isd-svg--14",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _c("use", {
                                attrs: {
                                  href: `#${_vm.iconIds.save}`,
                                  "xlink:href": `#${_vm.iconIds.save}`,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v("\n            Save Sequence\n          "),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "isd-modal__close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _c(
                        "svg",
                        {
                          staticClass: "isd-svg isd-svg--16",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("use", {
                            attrs: {
                              href: `#${_vm.iconIds.x}`,
                              "xlink:href": `#${_vm.iconIds.x}`,
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
                  ]
                ),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("BuildSequenceModal", {
        attrs: { sequence: _vm.selectedSequence },
        on: { save: _vm.handleSave, update: _vm.handleUpdate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }